<div class="flex justify-center items-center py-12 px-16 bg-[#18396C] rounded-bl-3xl rounded-br-3xl
  h-[120px]">
  <img class="h-[72.34px]" src="assets/logo.svg" alt="Katapulk Logo">
</div>
